import React, { useCallback } from "react";

import * as Flags from "../../../../lib/Flags";
import { useFlag } from "../../../../lib/hook/MiscHooks";

const DebugAlerts = () => {
	const disableApiCacheFlag = useFlag(Flags.DISABLE_API_CACHE);
	const requestCacheFlag = useFlag(Flags.REQUEST_CACHE);
	const demoModeFlag = useFlag(Flags.DEMO_MODE);

	const handleEnableAPICache = useCallback(() => {
		disableApiCacheFlag.reset();
	}, [disableApiCacheFlag]);
	const handleEnableLocaleRequestCache = useCallback(() => {
		requestCacheFlag.set(true);
	}, [requestCacheFlag]);

	return (
		<div className={"DebugArea__notices"}>
			{Flags.DISABLE_API_CACHE.is() && (
				<button
					onClick={handleEnableAPICache}
					className={"--error"}
					title={"Press to enable"}
				>
					API Cache Disabled
				</button>
			)}
			{!demoModeFlag.is() && !requestCacheFlag.is() && (
				<button
					onClick={handleEnableLocaleRequestCache}
					className={"--warn"}
					title={"Press to enable"}
				>
					Local Request Cache Disabled
				</button>
			)}
		</div>
	);
};

export default DebugAlerts;
